import { ClassName } from '@/global/types'

type Variant = 'circular' | 'rectangular' | 'rounded'

interface SkeletonProps {
  /**
   * Control the shape of the element.
   */
  variant?: Variant
  /**
   * Control the width of the element. Use tailwind width values.
   */
  width: string
  /**
   * Control the height of the element. Use tailwind width values.
   */
  height: string
  /**
   * Control the shade of gray
   */
  bgColor?: string
  /**
   * Add custom class name to the element.
   */
  className?: ClassName
}

const resolveBoderRadius = (variant?: Variant) => {
  if (variant === 'circular') return 'rounded-gl-border-radius-pill'
  if (variant === 'rectangular') return 'rounded-gl-border-radius-md'
  if (variant === 'rounded') return 'rounded-[50px]'
  return 'rounded-gl-border-radius-none'
}

const Skeleton = ({
  width,
  height,
  variant,
  bgColor = 'bg-gl-color-shades-gray-10',
  className
}: SkeletonProps) => {
  const boderRadius = resolveBoderRadius(variant)

  return (
    <div
      data-testid='skeleton'
      className={`${width} ${height} ${boderRadius} ${bgColor} animate-pulse ${className}`}
    />
  )
}

export type { SkeletonProps }

export { Skeleton }
